import { render, staticRenderFns } from "./openAi.vue?vue&type=template&id=19b4b282&"
import script from "./openAi.vue?vue&type=script&lang=js&"
export * from "./openAi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports